import TicketsIndex from '@/views/Tickets/TicketsIndex.vue';
import TicketShow from '@/views/Tickets/TicketShow.vue';
import TicketShowActions from '@/views/Tickets/TicketShowActions.vue';
import TicketAddPayment from '@/views/Tickets/TicketAddPayment.vue';
import TicketMakePayment from '@/views/Tickets/TicketMakePayment.vue';
import TicketFraudClaim from '@/views/Tickets/FraudClaim/Index.vue';
import TicketCommunicationMacros from '@/views/Tickets/Communications/Index.vue';
import TicketCancelPayment from '@/views/Tickets/TicketCancelPayment.vue';
import TicketModifyLoan from '@/views/Tickets/TicketModifyLoan.vue';
import TicketSettlement from '@/views/Tickets/TicketSettlement.vue';
import TicketPdsSettlement from '@/views/Tickets/TicketPdsSettlement.vue';
import TicketReschedulePayment from '@/views/Tickets/TicketReschedulePayment.vue';
import TicketRevokeAutopay from '@/views/Tickets/TicketRevokeAutopay.vue';
import TicketBankUpdateFunding from '@/views/Tickets/TicketBankUpdateFunding.vue';
import TicketSettlementReset from '@/views/Tickets/TicketSettlementReset.vue';
import TicketRescindLoan from '@/views/Tickets/RescindLoan/Index.vue';
import TicketChangePrimaryEmail from '@/views/Tickets/ChangePrimaryEmail/TicketChangePrimaryEmail.vue';
import TicketAutopay from '@/views/Tickets/Autopay/index.vue';
import TicketSupport from '@/views/Tickets/TicketSupport.vue';
import TicketCampaign from '@/views/Tickets/TicketCampaign.vue';
import TicketPDSPayment from '@/views/Tickets/TicketPDSPayment.vue';

import TicketPaymentWizard from '@/views/Tickets/PaymentWizard/Index.vue';
import TicketMakeReducedPayment from '@/views/Tickets/TicketMakeReducedPayment.vue';
import TicketStatementReport from '@/views/Tickets/TicketStatementReport.vue';
import TicketChangePrimaryPhone from '@/views/Tickets/ChangePrimaryPhone/TicketChangePrimaryPhone.vue';

export default [
  {
    path: 'ticket-support',
    name: 'ticket-support',
    component: TicketSupport,
    meta: {
      title: 'Ticket Support',
      permission: 'view ticket::support',
    },
    children: [
      {
        path: 'ticket-campaign',
        name: 'ticket-campaign',
        component: TicketCampaign,
        meta: {
          title: 'Ticket Campaign',
          permission: 'view ticket::outbound',
        },
      },
      {
        path: 'tickets',
        name: 'tickets',
        component: TicketsIndex,
        meta: {
          title: 'Tickets',
          permission: 'view ticket',
        },
      },
      {
        path: 'ticket/:id',
        // this parent route has a default route, it will render
        // by using the name ticket-show below
        // name: 'ticket-show',
        component: TicketShow,
        meta: {
          title: 'Ticket Information',
          permission: 'view ticket',
        },
        children: [
          {
            path: '',
            name: 'ticket-show',
            component: TicketShowActions,
            meta: {
              title: 'Ticket Actions',
              permission: 'view ticket',
            },
          },
          {
            path: 'add-payment',
            name: 'ticket-add-payment',
            component: TicketAddPayment,
            meta: {
              title: 'Ticket Add Payment',
              permission: 'view ticket::add-payment',
            },
          },
          {
            path: 'settlement',
            name: 'ticket-settlement',
            component: TicketSettlement,
            meta: {
              title: 'Ticket Settlement',
              permission: 'view ticket::settlement',
            },
          },
          {
            path: 'pds-settlement',
            name: 'ticket-pds-settlement',
            component: TicketPdsSettlement,
            meta: {
              title: 'Ticket PDS Settlement',
              permission: 'view ticket::settlement',
            },
          },
          {
            path: 'make-payment',
            name: 'ticket-make-payment',
            component: TicketMakePayment,
            meta: {
              title: 'Ticket Make Payment',
              permission: 'view ticket::make-payment',
            },
          },
          {
            path: 'pds-payment',
            name: 'ticket-pds-payment',
            component: TicketPDSPayment,
            meta: {
              title: 'Ticket PDS Payment',
              permission: 'view ticket::make-payment',
            },
          },
          {
            path: 'make-reduced-payment',
            name: 'ticket-make-reduced-payment',
            component: TicketMakeReducedPayment,
            meta: {
              title: 'Ticket Make Reduced Payment',
              permission: 'view ticket::make-reduced-payment',
            },
          },
          {
            path: 'fraud-claim',
            name: 'ticket-fraud-claim',
            component: TicketFraudClaim,
            meta: {
              title: 'Ticket Fraud Claim',
              permission: 'view ticket::fraud-claim',
            },
          },
          {
            path: 'communication-macros',
            name: 'ticket-communication-macros',
            component: TicketCommunicationMacros,
            meta: {
              title: 'Ticket Communications Macros',
              permission: 'view ticket::communication-macros',
            },
          },
          {
            path: 'cancel-payment',
            name: 'ticket-cancel-payment',
            component: TicketCancelPayment,
            meta: {
              title: 'Ticket Cancel Payment',
              permission: 'view ticket::cancel-payment',
            },
          },
          {
            path: 'reschedule-payment',
            name: 'ticket-reschedule-payment',
            component: TicketReschedulePayment,
            meta: {
              title: 'Ticket Reschedule Payment',
              permission: 'view ticket::reschedule-payment',
            },
          },
          {
            path: 'revoke-autopay',
            name: 'ticket-revoke-autopay',
            component: TicketRevokeAutopay,
            meta: {
              title: 'Ticket Revoke Autopay',
              permission: 'view ticket::revoke-autopay',
            },
          },
          {
            path: 'settlement-reset',
            name: 'ticket-settlement-reset',
            component: TicketSettlementReset,
            meta: {
              title: 'Ticket Settlement Reset',
              permission: 'view ticket::settlement',
            },
          },
          {
            path: 'bank-updated-funding',
            name: 'ticket-bank-update-funding',
            component: TicketBankUpdateFunding,
            meta: {
              title: 'Ticket Bank Update Funding',
              permission: 'view ticket::bank-update-funding',
            },
          },
          {
            path: 'rescind-loan',
            name: 'ticket-rescind-loan',
            component: TicketRescindLoan,
            meta: {
              title: 'Ticket Rescind Loan',
              permission: 'view ticket::rescind-loan',
            },
          },
          {
            path: 'payment-wizard',
            name: 'ticket-payment-wizard',
            component: TicketPaymentWizard,
            meta: {
              title: 'Ticket Payment Wizard',
              permission: 'view ticket::payment-wizard',
            },
          },
          {
            path: 'modify-loan',
            name: 'ticket-modify-loan',
            component: TicketModifyLoan,
            meta: {
              title: 'Ticket Modify Loan',
              permission: 'view ticket::modify-loan',
            },
          },
          {
            path: 'change-primary-email',
            name: 'ticket-change-primary-email',
            component: TicketChangePrimaryEmail,
            meta: {
              title: 'Ticket Change Primary Email',
              permission: 'view ticket::change-primary-email',
            },
          },
          {
            path: 'change-primary-phone',
            name: 'ticket-change-primary-phone',
            component: TicketChangePrimaryPhone,
            meta: {
              title: 'Ticket Change Primary Phone',
              permission: 'view ticket::change-primary-email',
            },
          },
          {
            path: 'statement-report',
            name: 'ticket-statement-report',
            component: TicketStatementReport,
            meta: {
              title: 'Ticket Statement Report',
              permission: 'view report::statements-report',
            },
          },
          {
            path: 'autopay',
            name: 'ticket-autopay',
            component: TicketAutopay,
            meta: {
              title: 'Ticket Autopay',
              permission: 'view ticket::cancel-payment',
            },
          },
        ],
      },
    ],
  },
];
